module.exports = __webpack_public_path__ + "static/media/ALGO.c742dc34.svg";